import { useContext } from 'react';
import { BrandsContext } from './Brands';

export const useUserBrands = () => {
  const context = useContext(BrandsContext);
  if (!context) {
    throw new Error('useUserBrands must be used within a BrandContextProvider');
  }
  return context;
};
